import _ from 'lodash';
import createReactClass from 'create-react-class';
import Immutable from 'immutable';
import React from 'react';
import PropTypes from 'prop-types';

import connect from 'components/lib/connect';
import CloseTopicsMenu from 'actions/conversation/topics_menu/close_topics_menu';
import ConversationMultiTopic from 'components/lib/conversation_multi_topic_deprecated';
import OpenTopicsMenu from 'actions/conversation/topics_menu/open_topics_menu';
import SearchTopic from 'actions/conversation/topics_menu/search_topic';
import SelectTopic from 'actions/conversation/topics_menu/select_topic';
import UpdateConversationTopicIds from 'actions/conversation/update_conversation_topic_ids';

const ConversationTopicActionConnector = createReactClass({
  propTypes: {
    className: PropTypes.string,
    conversation: PropTypes.object.isRequired,
    topicSuggestions: PropTypes.object,
  },

  getTopicSuggestions() {
    return this.props.topicSuggestions && this.props.topicSuggestions.addTopics
      ? this.props.topicSuggestions.addTopics
      : [];
  },

  getModelVersion() {
    return this.props.topicSuggestions && this.props.topicSuggestions.modelVersion;
  },

  handleTopicsChange(updatedTopicIds) {
    updatedTopicIds = _.filter(updatedTopicIds, id => this.props.getTopic(id));
    let prevTopicIds = this.props.conversation.topicIds;
    let add = _.difference(updatedTopicIds, prevTopicIds);
    let remove = _.difference(prevTopicIds, updatedTopicIds);
    if (add.length || remove.length) {
      let topicChanges = { add, remove };
      this.props.updateConversationTopicIds({
        id: this.props.conversation.id,
        customerId: this.props.customerId,
        topicChanges,
        modelVersion: this.getModelVersion(),
      });
    }
  },

  handleTopicSelect({ topicId, topicName, action, selectionType }) {
    const conversationId = this.props.conversation.id;
    let wasSuggested = _.includes(this.getTopicSuggestions(), topicId);
    this.props.onTopicSelect({
      topicId,
      topicName,
      conversationId,
      action,
      selectionType,
      wasSuggested,
      modelVersion: this.getModelVersion(),
    });
  },

  handleMenuOpen() {
    let numSuggestionsShown = _.difference(this.getTopicSuggestions(), this.props.conversation.topicIds).length;
    this.props.onMenuOpen({
      conversationId: this.props.conversation.id,
      numSuggestionsShown,
      numSuggestions: this.getTopicSuggestions().length,
      modelVersion: this.getModelVersion(),
    });
  },

  handleMenuClose() {
    this.props.onMenuClose({ conversationId: this.props.conversation.id, modelVersion: this.getModelVersion() });
  },

  handleTopicSearch() {
    this.props.onTopicSearch({ conversationId: this.props.conversation.id, modelVersion: this.getModelVersion() });
  },

  render() {
    return (
      <ConversationMultiTopic
        className={this.props.className}
        conversation={this.props.conversation}
        lastOpenedAt={this.props.lastOpenedAt}
        topics={this.props.topics}
        topicSuggestions={this.props.topicSuggestions}
        onMenuOpen={this.handleMenuOpen}
        onMenuClose={this.handleMenuClose}
        onTopicChange={this.handleTopicsChange}
        onTopicSelect={this.handleTopicSelect}
        onTopicSearch={this.handleTopicSearch}
      />
    );
  },
});

const ConversationTopicContainer = connect(mapStateToProps, mapExecuteToProps)(ConversationTopicActionConnector);
export default ConversationTopicContainer;

ConversationTopicContainer.propTypes = {
  conversationId: PropTypes.string.isRequired,
  customerId: PropTypes.string.isRequired,
  topicSuggestions: PropTypes.object,
};

function mapStateToProps({ getProvider, isFeatureEnabled }, { conversationId, customerId }) {
  const conversationsProvider = getProvider('conversations');
  const topicsProvider = getProvider('topics');
  const workflow = getProvider('conversationWorkflow').get();
  const lastOpenedAt = workflow.topicsLastOpenedAt;
  const topicSuggestionsProvider = getProvider('topicSuggestions');
  const agentAssistanceConfig = getProvider('agentAssistanceConfig').get();

  let topicSuggestions;
  if (agentAssistanceConfig.isEnabled('topicSuggestions')) {
    topicSuggestions = topicSuggestionsProvider.findBy({
      customerId,
      conversationId,
    });
  }

  return {
    conversation: conversationsProvider.find(conversationId),
    customerId,
    getTopic: id => topicsProvider.findBy({ id }),
    lastOpenedAt,
    topics: getTopicOptions(),
    topicSuggestions,
  };

  function getTopicOptions() {
    let topics = _.map(topicsProvider.findAll(), topic => ({
      id: topic.id,
      disabled: topic.disabled,
      name: topic.getNameWithAncestry(),
    }));
    return Immutable.fromJS(topics);
  }
}

function mapExecuteToProps(executeAction) {
  return {
    onMenuClose: params => executeAction(CloseTopicsMenu, params),
    onMenuOpen: params => executeAction(OpenTopicsMenu, params),
    onTopicSelect: params => executeAction(SelectTopic, params),
    onTopicSearch: params => executeAction(SearchTopic, params),
    updateConversationTopicIds: attrs => executeAction(UpdateConversationTopicIds, attrs),
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/containers/conversation_topic_container.jsx